// Supports weights 100-700
import '@fontsource-variable/josefin-sans';
import { VueQueryPlugin, VueQueryPluginOptions, QueryClient } from '@tanstack/vue-query';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import { router } from './router/router';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Import Vuetify styles
import '@mdi/font/css/materialdesignicons.css'; // Import Material Design Icons
import './assets/main.css'; // import as last style
import { vuetifySettings } from '@/theme/base.theme';

const vuetify = createVuetify(vuetifySettings);
import Vue3VideoPlayer from '@cloudgeek/vue3-video-player';
import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css';

import { useAuthStore } from './stores/modules/auth';
import { addAdminRoutes } from './router/admin/index';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { addStandardRoutes } from './router';
import { addUserRoutes } from './router/user';

Bugsnag.start({
  apiKey: '295549c3c9b46c77a63ca38aca5b364c',
  plugins: [new BugsnagPluginVue()],
});
BugsnagPerformance.start({ apiKey: '295549c3c9b46c77a63ca38aca5b364c' });
const bugsnagVue = Bugsnag.getPlugin('vue');
const app = createApp(App);
const pinia = createPinia();

const queryClient = new QueryClient();
const vueQueryOptions: VueQueryPluginOptions = {
  queryClient,
  enableDevtoolsV6Plugin: true,
};

app.use(VueQueryPlugin, vueQueryOptions);

pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(vuetify);
if (bugsnagVue) {
  app.use(bugsnagVue);
}
app.use(Vue3VideoPlayer);

// Await route addition before mounting the app
await (async () => {
  if (useAuthStore().isAdmin) {
    await addAdminRoutes(router);
  } else if (useAuthStore().isUser) {
    await addUserRoutes(router);
  }
  await addStandardRoutes(router);
})().then(() => {
  app.use(router);
  app.mount('#app');
});
